<template>
    <div class="cont-left "> 
        <div class="left-nav"  v-loading="loading">
            <div class="nav-list" v-for="item in leftNav" :key="item.type" >
                <div class="list-tit">{{item.value}}</div>
                <ul class="list">
                    <li class="list-info" :class="{ 'medical-active': medicalIndex == list.num }" 
                        v-for="list in item.list" :key="list.type" 
                        @click="leftNavTab(list )" >
                        <p class="info-label">{{list.facetName.trim()}}</p>
                         <span>{{list.facetCount}}</span>
                    </li> 
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {caseGetLeftList,caseGetSeniorLeftList} from '../../../io/api.js'
import {getCookieInfo} from '../../../io/getCookie.js'
export default {
    data () {  
        return {
            loading:false,
            keyWord:this.$route.query.keyWord||'',
            keywordSearchType:this.$route.query.keywordSearchType||'',
            medicalIndex:1,
            sourceType:this.$route.query.sourceType||'', 
            searchData:this.$route.query.searchData||{},
            leftNav:[
				{
                    value:'医案库信息',type:'yiankuList',leftSort:'MEDICAL_LIBRARY_ID',
                    list:[]
                },
				{
                    value:'名医',type:'doctorList',leftSort:'DOCTOR_NAME',
                    list:[]
                },
                {
                    value:'中医疾病',type:'zyDiseaseList',leftSort:'TCM_MEDICINE_DIAGNOSE',
                    list:[ ]
                },
                {
                    value:'西医疾病',type:'xyDiseaseList',leftSort:'WCM_MEDICINE_DIAGNOSE',
                    list:[]
                },
                //  {
                //     value:'中医证候',type:'zyDiseaseList',leftSort:'tcsy',
                //     list:[]
                // },
			],
        }
    },
    mounted () {
        this.getLeft_list()
    },
    methods: {
        getLeft_list(searchName,keyWord){
            this.advancedLeft_list()
            // if(this.sourceType=='advanced'){
            //     //高级检索 左侧列表
            //     this.advancedLeft_list()
            // }else{
            //     //正常检索左侧列表
            //     this.left_list(searchName,keyWord); 
            // }
            
        },
        //正常检索左侧列表
        left_list(searchName,keyWord){ 
            this.loading=true;
            // let keyword = searchName?searchName:this.keyWord;
            let params={ 
                keyword: keyWord||this.keyWord, 
                keywordSearchType: this.keywordSearchType,  
                knowledgeSearch:searchName||'',
                // searchMechanismName:' 中国中医科学院',
                // keywordSearchStore:""
            }
            caseGetLeftList(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    let num=0;
                    this.leftNav.forEach(item=>{ 
                        item.list=data.data[item.type];
                        item.list&&item.list.forEach(list=>{
                            num+=1;
                            list.num=num;
                            list.leftSort=item.leftSort
                        })
                    }); 
                    // this.tableList = data.data.list; 
                }else{
                    this.$message.error( data.msg||'请求失败～')
                }
                this.loading=false;
            })
        },
        //高级检索 左侧列表
        advancedLeft_list(){
            this.loading=true; 
            let highSearchWord = window.localStorage.getItem("highSearchWord")||getCookieInfo('highSearchWord')||'';
            let yianku=this.$route.query.medicalLibraryId.split(";");
            let params={
                // page: '1',  
                yianku:JSON.stringify(yianku),  
                highSearchWord, 
                // ...this.searchData
                //keywordSearchType: this.keywordSearchType,  
                // searchMechanismName:'',
                // keywordSearchStore:""
            }   
            this.$http.post(`/ckcest/consilia/getLeftSort`, params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    let num=0;
                    this.leftNav.forEach(item=>{ 
                        item.list=data.result[item.type];
                        item.list&&item.list.forEach(list=>{
                            num+=1;
                            list.num=num;
                            list.leftSort=item.leftSort
                        })
                    }); 
                    // this.tableList = data.data.list; 
                }else{
                    this.$message.error( data.msg||'请求失败～')
                }
                this.loading=false;
            })

        },
        leftNavTab(item){
            this.medicalIndex=item.num;
            this.$emit('leftNavTab',item)
        }
    }
}
</script> 